var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27653 18.9242C1.04319 18.6909 0.926528 18.4159 0.926528 18.0992C0.926528 17.7826 1.04319 17.5076 1.27653 17.2742L8.55153 9.99922L1.25153 2.69922C1.01819 2.46589 0.905861 2.19089 0.914528 1.87422C0.922528 1.55755 1.04319 1.28255 1.27653 1.04922C1.50986 0.815885 1.78486 0.699219 2.10153 0.699219C2.4182 0.699219 2.69319 0.815885 2.92653 1.04922L11.2265 9.34922C11.3099 9.44922 11.3725 9.55322 11.4145 9.66122C11.4559 9.76989 11.4765 9.88255 11.4765 9.99922C11.4765 10.1159 11.4559 10.2282 11.4145 10.3362C11.3725 10.4449 11.3099 10.5492 11.2265 10.6492L2.90153 18.9492C2.68486 19.1826 2.4182 19.2952 2.10153 19.2872C1.78486 19.2786 1.50986 19.1576 1.27653 18.9242Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.51de00198328808d7de9fab84c916092.svg";
export { ForwardRef as ReactComponent };